export default __webpack_public_path__ + "static/media/anatomy-image-8-bbb.79103cc2.png";